import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react'
import Bruh from "./components/name.mp3";
import ReactAudioPlayer from 'react-audio-player';
import {Helmet} from "react-helmet";
import ReactDOM from 'react-dom'
import Favicon from 'react-favicon'
import Snowfall from 'react-snowfall'
import SupportEngine from './SupportEngine';
import { Contactfrom } from './components/Contact/contactfrom';
import {
  BrowserRouter,
  Routes,
  Route,
  Router,
  Link,
  Outlet,
} from "react-router-dom";
import { Main } from './components/main';

import { NavBar } from './components/NavBar';
import { Projects } from './components/Projects';
import { Banner } from './components/Banner';
import { Footer } from './components/Footer';
import Support from './SupportEngine'
import { PriceList } from './components/PriceList';
import { Carier } from './components/Carier';
import { Company } from './components/company';
import { Games } from './components/games';
import { GameDesign } from './components/GameDesign';
import { Design } from './components/Design';
import { Education } from './components/Education';

import { Hackatons } from './components/Hackatons';
import Load from './components/Loader';
import { useState , useEffect } from 'react';
import { Loader } from 'three';
import { CSSProperties } from "react";
import { ClimbingBoxLoader, DotLoader, PacmanLoader } from 'react-spinners';
import Home from './components/Blog/pages/Home';
import Detail from './components/Blog/pages/Detail';
import AddEditBlog from './components/Blog/pages/AddEditBlog';
import About from './components/Blog/pages/About';
import NotFound from './components/Blog/pages/NotFound';
import { Auth } from './components/Blog/pages/Auth';
import ToyShop from './components/ToyShop';
import Ai from './components/ai';
import { Configuration, OpenAIApi } from "openai";



function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() =>{
    setLoading(true)
    setTimeout(()=>{
      setLoading(false)
    },5000)
  },[])

  const [prompt, setPrompt] = useState("");
  const [result, setResult] = useState("");
  //const [loading, setLoading] = useState(false);
  const [placeholder, setPlaceholder] = useState(
    "Search Bears with Paint Brushes the Starry Night, painted by Vincent Van Gogh.."
  );
  const configuration = new Configuration({
    apiKey: "",
  });

  const openai = new OpenAIApi(configuration);

  const generateImage = async () => {
    setPlaceholder(`Search ${prompt}..`);
    setLoading(true);
    const res = await openai.createImage({
      prompt: prompt,
      n: 1,
      size: "512x512",
    });
    setLoading(false);
    setResult(res.data.data[0].url);
  };
  

  
  return (
    
    <div className=''>
      
    {
    loading?  
 
      <div className='sweet-loading'>
        <ClimbingBoxLoader
              color={'hsla(110, 73%, 46%, 1)'}
              loading={loading}
              
              size={20}
              
            />

          </div>
    

    :  
   
    
    <Routes>    
    
     
   
        <Route path='/' element={<Main/>}> </Route>
        <Route path='/Contact' element={<Contactfrom/>}></Route>
        <Route path='/pricelist' element={<PriceList/>}></Route>
        <Route path='/Carier' element={<Carier/>}></Route>
        <Route path='/Company' element={<Company/>}></Route>
        <Route path='/Games' element={<Games/>}></Route>
        <Route path='/GameDesign' element={<Design/>}></Route>
       
        <Route path='/Education' element={<Education/>}></Route>
        <Route path='/ADS' element={<PriceList/>}></Route>
        <Route path='/Hackatons' element={<Hackatons/>}></Route>
        <Route path='/ToyShop' element={<ToyShop/>}></Route>
        <Route path='/ai'element={<Ai/>}></Route>  

   

    </Routes>    
    
   
        
   
    
   
    }
    
   </div>
   
   
    
 

  )
      
      
 
    
      
  
};

export default App;


// <Route path='/Design' element={<Design/>}></Route>